import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericPolluxResult } from '../../../models/generic-pollux-result';
import { AppServiceHelperService } from '../../../services/app-service-helper.service';
import { RxjsHelper } from '../../../components/common/utils/rxjs-helper';

/**
 * Comparables delete service
 */
@Injectable({
  providedIn: 'root'
})
export class ComparablesDeleteService {
  /**
   * canDeletePropertiesResource
   */
  private readonly _canDeletePropertiesResource: string;

  /**
   * DeletePropertiesResource
   */
  private readonly _deletePropertiesResource: string;

  /**
   * DeleteLeaseTransactionsResource
   */
  private readonly _deleteLeaseTransactionsResource: string;

  /**
   * DeleteLeaseValuationsResource
   */
  private readonly _deleteLeaseValuationsResource: string;

  /**
   * Constructor
   * @param httpClient
   * @param appServiceHelper
   */
  constructor(private httpClient: HttpClient, private appServiceHelper: AppServiceHelperService) {
    this._canDeletePropertiesResource = this.appServiceHelper.getServiceEndpoint('pollux.comparables.api', 'Properties/candelete');
    this._deletePropertiesResource = this.appServiceHelper.getServiceEndpoint('pollux.comparables.api', 'Properties/delete/multiple');
    this._deleteLeaseTransactionsResource = this.appServiceHelper.getServiceEndpoint('pollux.comparables.api', 'comparables/LeaseTransaction/delete/multiple');
    this._deleteLeaseValuationsResource = this.appServiceHelper.getServiceEndpoint('pollux.comparables.api', 'comparables/Valuations/delete/multiple');
  }

  /**
   * Checks if properties can be deleted
   * @param oidslist Array of property oids
  */
  public async canDeleteComparablesProperties(oidslist: number[]): Promise<boolean> {
    const promises = oidslist.map(oid => RxjsHelper.toPromise(this.httpClient.get(`${this._canDeletePropertiesResource}?oid=${oid}`)));

    const results = await Promise.all<any>(promises);
    return results.filter(r => !r.success).length === 0; 
  }

  /**
   * Deletes properties
   * @param oidslist Array of oids
  */
  public async deleteComparablesProperties(oidslist: number[]): Promise<GenericPolluxResult> {
    const result = await RxjsHelper.toPromise(this.httpClient.post<any>(`${this._deletePropertiesResource}`, oidslist));
    return { success: result.m_Item1, message: result.m_Item2 };//convert Tuple<bool, string> to GenericPolluxResult
  }

  /**
   * Deletes lease transactions
   * @param oidslist Array of oids
  */
  public async deleteComparablesLeaseTransactions(oidslist: number[]): Promise<GenericPolluxResult> {
    const result = await RxjsHelper.toPromise(this.httpClient.post<any>(`${this._deleteLeaseTransactionsResource}`, oidslist));
    return { success: result.m_Item1, message: result.m_Item2 };//convert Tuple<bool, string> to GenericPolluxResult
  }

  /**
   * Deletes valuations
   * @param oidslist Array of oids
  */
  public async deleteComparablesValuations(oidslist: number[]): Promise<GenericPolluxResult> {
    const result = await RxjsHelper.toPromise(this.httpClient.post<any>(`${this._deleteLeaseValuationsResource}`, oidslist));
    return { success: result.m_Item1, message: result.m_Item2 };//convert Tuple<bool, string> to GenericPolluxResult
  }
}
